require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /var/www/beauty-shop.ru/~/core-js/modules/es7.symbol.async-iterator.js
// module id = 930
// module chunks = 32